import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";
import { EvidenceChip, HashChip } from "@/components/common/EvidenceChip";
import { ImmutableBadge } from "@/components/common/ImmutableBadge";
import { Link } from "react-router-dom";

export default function EvidencePage() {
  const [records, setRecords] = useState([]);
  useEffect(() => { api.get("/evidence").then(r => setRecords(r.data)); }, []);

  return (
    <div data-testid={TID.evidencePage} className="space-y-6 animate-fade-in-up">
      <header className="flex items-end justify-between border-b border-border pb-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-altara-teal font-semibold">Evidence Repository</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight text-altara-ink mt-1">Immutable, hash-chained evidence</h1>
          <p className="text-sm text-muted-foreground mt-1">Every recommendation and dashboard tile must trace back here. Nothing gets published without evidence.</p>
        </div>
        <div className="font-mono text-[10px] text-muted-foreground">{records.length} records</div>
      </header>

      <div className="border border-slate-200 rounded-sm overflow-hidden bg-white">
        <table data-testid={TID.evidenceTable} className="w-full text-xs">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.15em] text-slate-500">
            <tr>
              <th className="text-left px-4 py-2 font-medium">Kind</th>
              <th className="text-left px-4 py-2 font-medium">Title / Summary</th>
              <th className="text-left px-4 py-2 font-medium">Source</th>
              <th className="text-left px-4 py-2 font-medium">Captured</th>
              <th className="text-left px-4 py-2 font-medium">Chain</th>
              <th className="text-left px-4 py-2 font-medium">Consumer</th>
              <th className="text-left px-4 py-2 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {records.map(r => (
              <tr key={r.evidence_id} className="border-t border-slate-100 hover:bg-slate-50/60">
                <td className="px-4 py-2 uppercase text-[10px] tracking-widest text-slate-600">{r.kind}</td>
                <td className="px-4 py-2">
                  <div className="font-medium text-slate-800">{r.title}</div>
                  <div className="text-[10px] text-slate-500">{r.summary}</div>
                  <EvidenceChip id={r.evidence_id} className="mt-1" />
                </td>
                <td className="px-4 py-2 text-slate-600">{r.source_system}</td>
                <td className="px-4 py-2 font-mono text-[10px] text-slate-500">{new Date(r.captured_at).toLocaleString()}</td>
                <td className="px-4 py-2"><HashChip hash={r.content_hash} prevHash={r.prev_hash} /></td>
                <td className="px-4 py-2">
                  {r.consumer_id && <Link className="font-mono text-[10px] text-altara-teal hover:text-altara-deep" to={`/consumers/${r.consumer_id}`}>{r.consumer_id.slice(0, 12)}…</Link>}
                </td>
                <td className="px-4 py-2"><ImmutableBadge /></td>
              </tr>
            ))}
            {records.length === 0 && <tr><td colSpan={7} className="px-4 py-8 text-center text-slate-400">No evidence yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
